import {useState, useEffect} from 'react'
import dayjs from 'dayjs'
export default function MostrarIngreso(props) {

    const [ultima_s, setUltima_s] = useState({})
    const [ultima_d, setUltima_d] = useState({})
    const [cate, setCate] = useState('')

    function registrar() {
        fetch(props.back + 'admin/registrar_ingreso/id/' + props.socio.id ,{
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
            })
        .then (response => response.json())
        .then (json => {
            if(json.data==='Ok') {
                props.setSocio({...props.socio, id:0}) 
                props.limpiar()
            }
        })
    }
    
    const [cuales, setCuales] = useState ([])
    useEffect (() => {
        {console.log(props.socio)}
        function cuales() {
            return props.actividades.map(a => {
                return props.socio.actividad.map (e => {
                    return e.actividadId === a.id ? a.nombre : ''
                })
            })
        }
        setCuales(cuales())

        function traer_detallec(que,donde) {
            fetch(props.back + 'admin/deta_cuota/id/' + que, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + props.token,
                    'Content-Type': 'application/json' 
                }
            })
            .then (response => response.json())
            .then (json => donde(json))
        }

        function categoria(socio) {
            if (!socio.id) return
            const hoy = dayjs(new Date())
            const nac = dayjs(socio.nacimiento)
            const ed = hoy.diff(nac, 'year')

            const alta_soc = dayjs(socio.alta_sistema)
            const ant = hoy.diff(alta_soc, 'year')
            var cual = 'Menor'
            if (ed>=5 && ed<18) cual='Cadete'
            if (ed>=18 && ed<60 && socio.sexo==='F') cual='Dama'
            if (ed>=18 && ed<65 && socio.sexo==='M') cual='Activo'
            if ((ed>=60 && ant<30 && props.socio.sexo==='F') || (ed>=65 && ant<30 && props.socio.sexo==='M')) setCate('Jubilado')
            if (ed>=48 && ant>=30) cual='Vitalicio'

            setCate(cual)
        }
    traer_detallec(props.socio.ultima_s, setUltima_s)
    traer_detallec(props.socio.ultima_d, setUltima_d)
    categoria(props.socio)
    },[props.socio])

    return (<>
        <div className="flex flex-row">
            <img className="max-h-64 ml-5" alt='Imagen socio' src={"https://clubrionegro.ar/back/uploads/" + props.socio.imagen } />
            <div className="flex flex-col">
                <div className="grid grid-cols-3 gap-4 text-lg ml-10">
                    <div className="flex flex-col px-5">
                        <p>Socio</p>
                        <p>{' ' + props.socio.apellido + ' ' + props.socio.nombre}</p>
                        <p>DNI:{' ' + props.socio.documento}</p>
                        <p>Teléfono:{' ' + props.socio.telefono}</p>
                        {cuales && cuales.length ?
                            <ul className="text-lg text-red-600">
                                {cuales.map(a => {if (a!=='')
                                        return <li>{a}</li>
                                    }
                               )}   
                            </ul>
                            :
                            ''
                        }
                    </div>
                    <div className="flex flex-col ml-5 px-5">
                        <p>Autorizado</p>
                        <p>{' ' + props.socio.apellido_ref + ' ' + props.socio.nombre_ref}</p>
                        <p>DNI:{' ' + props.socio.documento_ref}</p>
                        <p>Teléfono:{' ' + props.socio.telefono_ref}</p>
                   </div>
                   {cate !== 'Menor' && cate!=='Vitalicio' ?
                   <div classname="flex flex-col w-full">
                        <div className="flex flex-row w-full justify-between">
                            <label>Última socio</label> 
                            <label className="text-right">{ultima_s.descrip}</label>
                        </div>
                        <div className="flex flex-row w-full justify-between">
                            <label>Última deportiva</label> 
                            <label className="text-right">{ultima_d.descrip}</label>
                        </div>
                    </div>
                    :
                    cate==='Menor' ?
                        <div className="text-2xl">MENOR - No Abona Cuota</div>
                    :
                        <div className="text-2xl">VITALICIO - No Abona Cuota</div>
                    }
                
                </div>
                <div className="w-full text-center">
                    <button
                        className="h-24 w-32 text -2xl p-3 mt-5 bg-green-300 hover:bg-green-700 hover:text-white border-2 border-green-700 rounded-xl"
                        onClick={(e => registrar())}
                    >
                    Marcar Ingreso
                    </button>
                </div>
               
            </div>
        </div>
    </>)             
}
